function createParticipantsSummaryOverviewRowNotificationServices(
  summaryOverview
) {
  const { totalPlans, totalParticipants } = summaryOverview
  const pluralizedPlan = totalPlans === 1 ? 'plan' : 'plans'
  const pluralizedParticipant =
    totalParticipants === 1 ? 'participant' : 'participants'

  return {
    planName: `${totalPlans} ${pluralizedPlan}`,
    participants: `${totalParticipants} ${pluralizedParticipant}`,
  }
}

export default createParticipantsSummaryOverviewRowNotificationServices
